import React from 'react';
import PropTypes from 'prop-types';
import { Badge, UncontrolledTooltip } from 'reactstrap';
import { NavLink, useLocation } from 'react-router-dom';

const formatBadgeCount = (count) => {
  if (!count || count <= 0) return null;
  return count > 99 ? '99+' : String(count);
};

const ACTION_DOT_ICON = 'action-dot';

const SidebarLinkCustomIcon = ({
  title,
  icon,
  newLink,
  route,
  link,
  badgeCount,
  badgeTooltip,
  onClick,
}) => {
  const displayCount = formatBadgeCount(badgeCount);
  const internal = SidebarEntryInternal(
    icon,
    title,
    newLink,
    displayCount,
    badgeTooltip,
  );
  const location = useLocation();

  if (link) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        {internal}
      </a>
    );
  }

  if (onClick) {
    return (
      <a
        href={route || '#'}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        {internal}
      </a>
    );
  }

  return (
    <NavLink
      to={route}
      state={{ from: location }}
      className={({ isActive }) => (isActive ? 'sidebar__link-active' : '')}
    >
      {internal}
    </NavLink>
  );
};

const SidebarEntryInternal = (
  icon,
  title,
  newLink,
  displayCount,
  badgeTooltip,
) => (
  <li className="sidebar__link custom_sidebar_link">
    {icon === ACTION_DOT_ICON ? (
      <span className="sidebar-action-dot" aria-hidden="true" />
    ) : icon ? (
      <img
        src={`/img/icons/${icon}.png`}
        className={`icons8-${icon}`}
        alt="Icon"
      />
    ) : (
      ''
    )}
    <p className="sidebar__link-title">
      {title}
      {displayCount && (
        <>
          <Badge
            id={`sidebar-triage-badge-${String(title)
              .toLowerCase()
              .replace(/\s+/g, '-')}`}
            className="sidebar__link-badge sidebar__link-badge--count"
            tabIndex={0}
          >
            <span>{displayCount}</span>
          </Badge>
          {badgeTooltip ? (
            <UncontrolledTooltip
              placement="right"
              target={`sidebar-triage-badge-${String(title)
                .toLowerCase()
                .replace(/\s+/g, '-')}`}
              delay={{ show: 100, hide: 50 }}
              innerClassName="lp-info-tooltip"
            >
              {badgeTooltip}
            </UncontrolledTooltip>
          ) : null}
        </>
      )}
      {!displayCount && newLink && (
        <Badge className="sidebar__link-badge">
          <span>New</span>
        </Badge>
      )}
    </p>
  </li>
);

SidebarLinkCustomIcon.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  route: PropTypes.string,
  link: PropTypes.string,
  badgeCount: PropTypes.number,
  badgeTooltip: PropTypes.node,
  onClick: PropTypes.func,
};

SidebarLinkCustomIcon.defaultProps = {
  icon: '',
  newLink: false,
  route: '/',
  link: undefined,
  badgeCount: 0,
  badgeTooltip: '',
  onClick: undefined,
};

export default SidebarLinkCustomIcon;
